module.exports = __webpack_public_path__ + "img/nave-05.f3210dcf.jpg";